"use client";

import { useState, useEffect } from 'react'
import { Star, User, Calendar, MessageSquare, Trash2 } from 'lucide-react'
import { supabase } from '../../../../Supabase/SupabaseClient' // Ajusta la ruta según tu estructura
import styles from "./TabContents.module.css"

function Opiniones() {
  const [reviews, setReviews] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)


  // Cargar reseñas al montar el componente
  useEffect(() => {
    fetchReviews()
  }, [])

  const fetchReviews = async () => {
    try {
      setLoading(true)
      const { data, error } = await supabase
        .from('reseñas')
        .select('*')
        .order('createdAt', { ascending: false })

      if (error) throw error
      console.log('Datos cargados:', data)
      setReviews(data || [])
    } catch (error) {
      console.error('Error cargando reseñas:', error)
      setError('Error al cargar las reseñas: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

 

  // Eliminar reseña
  const eliminarReview = async (id) => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar esta reseña?')) return

    try {
      const { error } = await supabase
        .from('reseñas')
        .delete()
        .eq('id', id)

      if (error) throw error
      
      // Actualizar estado local
      setReviews(reviews.filter(review => review.id !== id))
    } catch (error) {
      console.error('Error eliminando reseña:', error)
      alert('Error al eliminar la reseña: ' + error.message)
    }
  }

  
  // Renderizar estrellas como en tu componente original
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={16}
        className={i < rating ? 'filled-star' : 'empty-star'}
        style={{
          color: i < rating ? '#ffd700' : '#e0e0e0',
          fill: i < rating ? '#ffd700' : 'transparent'
        }}
      />
    ))
  }

  // Formatear fecha
  const formatearFecha = (fecha) => {
    if (!fecha) return 'Fecha no disponible'
    return new Date(fecha).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  

  if (loading) {
    return (
      <div className={styles.tabContent}>
        <h2 className={styles.tabTitle}>Gestión de Reseñas</h2>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          padding: '60px',
          fontSize: '16px',
          color: '#666'
        }}>
          Cargando reseñas...
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.tabContent}>
        <h2 className={styles.tabTitle}>Gestión de Reseñas</h2>
        <div style={{ 
          padding: '20px', 
          backgroundColor: '#fee', 
          border: '1px solid #fcc', 
          borderRadius: '12px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          <p style={{ color: '#d73527', margin: '0 0 15px 0', fontSize: '16px' }}>{error}</p>
          <button 
            onClick={fetchReviews}
            style={{ 
              padding: '12px 24px', 
              backgroundColor: '#007bff', 
              color: 'white', 
              border: 'none', 
              borderRadius: '8px', 
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            Reintentar
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.tabContent}>
      <h2 className={styles.tabTitle}>Gestión de Reseñas</h2>
      
      {/* Filtros y estadísticas */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '30px',
        flexWrap: 'wrap',
        gap: '15px'
      }}>
       

        {/* Estadísticas rápidas */}
        <div style={{ 
          display: 'flex', 
          gap: '20px',
          alignItems: 'center'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>
              {reviews.length}
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>Total</div>
          </div>
          
         
          
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
              {reviews.length > 0 && reviews.some(r => r.rating)
                ? (reviews.filter(r => r.rating).reduce((acc, r) => acc + r.rating, 0) / 
                   reviews.filter(r => r.rating).length).toFixed(1)
                : '0.0'
              }
            </div>
            <div style={{ fontSize: '12px', color: '#666' }}>Promedio</div>
          </div>
        </div>
      </div>

      {/* Lista de reseñas */}
      {reviews.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '60px 20px', 
          color: '#666',
          backgroundColor: '#f8f9fa',
          borderRadius: '12px',
          border: '2px dashed #dee2e6'
        }}>
          <MessageSquare size={48} color="#ccc" style={{ marginBottom: '15px' }} />
          <p style={{ fontSize: '18px', margin: 0 }}>
            {reviews.length === 0 ? 'No hay reseñas disponibles' : 'No hay reseñas que coincidan con el filtro'}
          </p>
        </div>
      ) : (
        <div style={{ 
          display: 'grid',
          gap: '20px'
        }}>
          {reviews.map((review) => (
            <div 
              key={review.id} 
              style={{ 
                border: '2px solid #e1e5e9',
                borderRadius: '16px', 
                padding: '20px',
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'
                e.currentTarget.style.transform = 'translateY(-2px)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              

              {/* Contenido principal como en tu Review original */}
              <div style={{ 
                display: 'flex',
                gap: '15px',
                alignItems: 'flex-start',
                marginBottom: '15px'
              }}>
                {/* Avatar */}
                <div style={{ flexShrink: 0 }}>
                  <img
                    src={review.image || "/placeholder.svg"}
                    alt={review.author || 'Usuario'}
                    style={{
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #e1e5e9'
                    }}
                  />
                </div>

                {/* Información del usuario */}
                <div style={{ flex: 1 }}>
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '8px'
                  }}>
                    <User size={16} color="#666" />
                    <span style={{ 
                      fontSize: '16px', 
                      fontWeight: 'bold',
                      color: '#333'
                    }}>
                      {review.author || 'Cliente Anónimo'}
                    </span>
                  </div>
                  
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                  }}>
                    <Calendar size={14} color="#999" />
                    <span style={{ 
                      fontSize: '13px', 
                      color: '#666' 
                    }}>
                      {formatearFecha(review.createdAt)}
                    </span>
                  </div>

                  {/* Rating */}
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '15px'
                  }}>
                    <div style={{ display: 'flex', gap: '2px' }}>
                      {renderStars(review.rating)}
                    </div>
                    <span style={{ 
                      fontSize: '14px',
                      color: '#666',
                      fontWeight: 'bold'
                    }}>
                      ({review.rating}/5)
                    </span>
                  </div>
                </div>
              </div>

              {/* Comentario */}
              <div style={{ 
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                borderLeft: '4px solid #007bff'
              }}>
                <p style={{ 
                  margin: 0, 
                  lineHeight: '1.6',
                  fontSize: '15px',
                  color: '#333',
                  fontStyle: 'italic'
                }}>
                  "{review.content || 'Sin comentario'}"
                </p>
              </div>

              {/* Botones de acción */}
              <div style={{ 
                display: 'flex', 
                gap: '12px', 
                justifyContent: 'flex-end',
                paddingTop: '15px',
                borderTop: '1px solid #e1e5e9'
              }}>
                
                
                <button
                  onClick={() => eliminarReview(review.id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    backgroundColor: '#dc3545',
                    color: 'white',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
                >
                  <Trash2 size={14} />
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Opiniones